import db from '@/firebase/init'
import moment from "moment";
import * as firebase from 'firebase';

let freundeinfo=[];
let messages=[];
let actualuser;
let destinationUser="Harald";

export function setUser(name){
  actualuser=name;
}

export function getUser() {
  return actualuser;
}
export function setDestinationUser(name){
  destinationUser=name;
}

export function getDestinationUser() {
  return destinationUser;
}


//Entfernen einen Freund
export function modulremoveArrayElement(ref,name, nameRemove, router) {
  ref.get().then(snapshot => {
    let ref2 =  db.collection('friends').doc(snapshot.docs[0].id).update({
      friends: firebase.firestore.FieldValue.arrayRemove(nameRemove)
    }).then(() => {
      console.log("removeArrayElement")
      // pushroute(name, nameAdd, router)
    })
      .catch(err => {
        console.log('Error modulremoveArrayElement', err);
      }); ;
    ;
  })
}

//Füge einen Freund hinzu
export function moduladdArrayElement(ref, name, nameAdd, router, pushDestination) {
  ref.get().then(snapshot => {
  let ref2 = db.collection('friends').doc(snapshot.docs[0].id).update({
      friends: firebase.firestore.FieldValue.arrayUnion(nameAdd)
    }).then(() => {
      modulPushroute(name, nameAdd, router, pushDestination)
    })
      .catch(err => {
        console.log('Error moduladdArrayElement', err);
      });
  })
}

export function modulPushroute(name, neuePerson, router, pushDestination){
  router.push({name: pushDestination, params: {name: name, neuePerson: neuePerson}});
}





// WEBPACK FOOTER //
// ./src/firebase/GlobalDBFunctions.js